<template>
  <v-container>
    <v-row>
      <v-col>
        <p class="text-h3">What is ESP-Updater?</p>
        <p>
          ESP Updater is an open source tool for use with ESP devices & Firebase
          to perform Over The Air (OTA) updates to your devices.
        </p>
        <p>
          We use Google Firebase as our backend and database. After installing
          our firmware and setting up a Firebase Project, your devices will live
          under a
          <span class="font-weight-bold">Devices</span> collection within the
          database. This is the location where your devices will be imported
          from. This database belongs to you and is made accessible through our
          Updater by providing your database Host and Secret, both of which are
          stored locally on your browser, we do not keep any of this data.
        </p>
        <p class="mt-3 text-h6">Setting Up:</p>
        <p>There are 3 steps to setup your device ready to use our updater.</p>
        <v-list flat>
          <v-list-item-group color="primary">
            <v-list-item router link to="/docs/firebase">
              <v-list-item-action>
                <v-list-item-title>1.</v-list-item-title>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  >Setup your own Firebase Project</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item router link to="/docs/device">
              <v-list-item-action>
                <v-list-item-title>2.</v-list-item-title>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Download our ESP Firmware</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-list-item-title>3.</v-list-item-title>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Import your Devices</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
